export default __webpack_public_path__ + "static/media/swimmingpool.0f10f843.svg";